module.exports = __webpack_public_path__ + "static/media/sun.e12a500b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/sun.svg
// module id = 103
// module chunks = 0